
import {Container} from 'react-bootstrap';
import './AdminFooter.scss';

const AdminFooter = () => {
    return (
        <Container fluid >
            
        </Container>
    )
}

export default AdminFooter;